"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextRowSecondary = exports.StyledTextRow = exports.CellIcon = exports.FlexContainerVertical = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
var global_styles_1 = require("../../Global/global.styles");
exports.FlexContainerVertical = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: calc(100% - ", ");\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  width: calc(100% - ", ");\n  display: flex;\n  flex-wrap: wrap;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.large;
});
exports.CellIcon = (0, styled_components_1.default)(global_styles_1.StyledIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-inline-end: ", ";\n  color: ", ";\n"], ["\n  margin-inline-end: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.black;
});
exports.StyledTextRow = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  color: ", ";\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.black;
});
exports.StyledTextRowSecondary = (0, styled_components_1.default)(exports.StyledTextRow)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.emperor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
